<template>
  <main
    class="c-ui-dropdown"
    :class="[{'enable' : value}, {'c-ui-dropdown--light' : theme === 'light'}]"
  >
    <section>
      <slot name="toggle"></slot>
    </section>
    <section class="c-ui-dropdown__menu position-relative">
      <section class="c-ui-dropdown__menu-body br--small py-2">
        <slot name="menu">
        </slot>
      </section>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    return {
      switcher: false,
    };
  },
  props: ['theme', 'value'],
};
</script>
